//Size keyword is reserved by inputs.

export const SCALE = /*#__PURE__*/Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'large',
  default: 'medium'
});
export const VALIDATION_STATES = /*#__PURE__*/Object.freeze({
  success: 'success',
  error: 'error',
  neutral: 'neutral',
  pending: 'pending'
});
export const LAYOUT = {
  basic: 'basic',
  column: 'column',
  grid: 'grid'
};
export const CONTAINER_SIZES = {
  'small': '40px',
  'medium': '50px',
  'default': '50px',
  'large': '60px'
};
export const FONT_SIZES = {
  'small': '13px',
  'medium': '16px',
  'default': '16px',
  'large': '20px'
};
export const RADIUS_SIZES = {
  'small': '4px',
  'medium': '5px',
  'default': '5px',
  'large': '6px'
};
export const LINE_HEIGHT_SIZES = {
  'small': '16px',
  'medium': '20px',
  'default': '20px',
  'large': '24px'
};

// Using RecursiveLabs co-browsing integration. We are adding this className to any field we want redacted.
export const RL_REDACTED_CLASSNAME = 'rl-redacted';

// Keyboard event values
export const EVENT_KEYS = {
  arrow_up: 'ArrowUp',
  arrow_down: 'ArrowDown',
  arrow_left: 'ArrowLeft',
  arrow_right: 'ArrowRight',
  backspace: 'Backspace',
  end: 'End',
  enter: 'Enter',
  escape: 'Escape',
  home: 'Home',
  space: ' ',
  tab: 'Tab'
};